import { render, staticRenderFns } from "./battery-car.vue?vue&type=template&id=52b47ebe&scoped=true&"
import script from "./battery-car.vue?vue&type=script&lang=js&"
export * from "./battery-car.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b47ebe",
  null
  
)

export default component.exports